(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Popper"), require("RhgCommon"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Popper", "RhgCommon", ], factory);
	else if(typeof exports === 'object')
		exports["search-map-destinations.c5da3c8c"] = factory(require("Popper"), require("RhgCommon"), require("vue"));
	else
		root["search-map-destinations.c5da3c8c"] = factory(root["Popper"], root["RhgCommon"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__80246__, __WEBPACK_EXTERNAL_MODULE__42730__, __WEBPACK_EXTERNAL_MODULE__9274__) {
return 